import { isMtuFreePlan, isMtuTeamPlan } from 'lib/utils/billing-plans'

export function getPlansRequest (state) {
  const { isRequesting, didRequestFail, didRequest } = state.plans
  return { isRequesting, didRequestFail, didRequest }
}

export function getSortedPlans (state) {
  const plans = state.plans.data || []
  return plans.sort(sortById)
}

export function getPlanById (state, id) {
  const plans = state.plans.data || []
  for (let i = 0; i < plans.length; i++) {
    if (plans[i].id === id) {
      return plans[i]
    }
  }
  return null
}

export function getNextPlan (state, billing) {
  const currentPlanId = billing.data.subscription.plan.id
  const nextPlanId = isMtuFreePlan(currentPlanId) ? 'team-$100-1-month' : 'developer'
  return getPlanById(state, nextPlanId)
}

export function doesPlanRequireCreditCard (planId) {
  if (isMtuTeamPlan(planId)) {
    return true
  }
  return false
}

// TODO(stephenmathieson) this is pretty brittle and will break if we add another plan type
function sortById (a, b) {
  if (a.id === b.id) {
    return 0
  }

  if (a.id === 'developer') {
    return -1
  }

  if (b.id === 'business') {
    return -1
  }

  return 1
}



// WEBPACK FOOTER //
// ./selectors/plans.js